const normalizeLocale = (locale = 'en') => {
  if (!locale) return 'en-US';
  const lowered = String(locale).toLowerCase();
  if (lowered.startsWith('pl')) return 'pl-PL';
  return 'en-US';
};

const toValidDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDisplayDateTime = (value, locale = 'en') => {
  const date = toValidDate(value);
  if (!date) return '-';

  const formatter = new Intl.DateTimeFormat(normalizeLocale(locale), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  const parts = formatter.formatToParts(date);
  const map = parts.reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});

  return `${map.day} ${map.month} ${map.year}, ${map.hour}:${map.minute}`;
};
